import React from 'react';
import './GenericPopup.css';

const GenericPopup = ({ onClose, children, title, showCloseButton = true }) => {
  return (
    <div className="popup-container" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        {showCloseButton && (
          <button className="close-button" onClick={onClose}>×</button>
        )}
        {title && <h2 className="popup-title">{title}</h2>}
        <div className="popup-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default GenericPopup;
